import { render, staticRenderFns } from "./DeliveryApply.vue?vue&type=template&id=1656236c"
import script from "./DeliveryApply.vue?vue&type=script&lang=js"
export * from "./DeliveryApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports